// Pulled from https://github.com/chakra-ui/chakra-ui/tree/main/packages/utils/src

import Color from 'tinycolor2';
import { get } from './object';

/**
 * Get the color raw value from theme
 * @param theme - the theme object
 * @param color - the color path ("green.200")
 * @param fallback - the fallback color
 */
export var getColor = (theme, color, fallback) => {
  var hex = get(theme, "colors.".concat(color), color);
  var isValid = Color(hex).isValid();
  return isValid ? hex : fallback;
};

/**
 * Determines if the tone of given color is "light" or "dark"
 * @param color - the color in hex, rgb, or hsl
 */
export var tone = color => theme => {
  var hex = getColor(theme, color);
  var isDark = Color(hex).isDark();
  return isDark ? 'dark' : 'light';
};

/**
 * Determines if a color tone is "dark"
 * @param color - the color in hex, rgb, or hsl
 */
export var isDark = color => theme => tone(color)(theme) === 'dark';

/**
 * Determines if a color tone is "light"
 * @param color - the color in hex, rgb, or hsl
 */
export var isLight = color => theme => tone(color)(theme) === 'light';

/**
 * Make a color transparent
 * @param color - the color in hex, rgb, or hsl
 * @param amount - the amount white to add
 */
export var transparentize = (color, opacity) => theme => {
  var raw = getColor(theme, color);
  return Color(raw).setAlpha(opacity).toRgbString();
};